module.exports = __webpack_public_path__ + "static/media/ThumbnailStill17.6b543501.png";